// /src/components/fondos/BoxBackground.js

import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";

// Definición de la animación
const moveShapes = keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 0.8;
  }
  20% {
    transform: translate(-20vw, 20vh) rotate(60deg);
    opacity: 0.5;
  }
  40% {
    transform: translate(30vw, 50vh) rotate(120deg);
    opacity: 0.7;
  }
  60% {
    transform: translate(-10vw, 80vh) rotate(180deg);
    opacity: 0.4;
  }
  80% {
    transform: translate(40vw, 10vh) rotate(240deg);
    opacity: 0.6;
  }
  100% {
    transform: translate(0, 0) rotate(360deg);
    opacity: 0.8;
  }
`;

// Array de configuraciones para las formas animadas
const shapes = [
  { size: 20, top: '10%', left: '5%', color: '#2196F3', duration: '20s', delay: '0s' }, // Azul
  { size: 15, top: '50%', left: '80%', color: '#4CAF50', duration: '25s', delay: '2s' }, // Verde
  { size: 25, top: '20%', left: '60%', color: '#FF5722', duration: '30s', delay: '5s' }, // Naranja
  { size: 18, top: '80%', left: '20%', color: '#FF9800', duration: '15s', delay: '8s' }, // Amarillo
  { size: 22, top: '70%', left: '90%', color: '#2196F3', duration: '22s', delay: '10s' }, // Azul
  { size: 10, top: '5%', left: '45%', color: '#4CAF50', duration: '18s', delay: '12s' }, // Verde
];

const FondoDinamico = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#FFFFFF', // Fondo blanco como mencionaste
        overflow: 'hidden', // Importante para que las formas no creen barras de desplazamiento
      }}
    >
      {/* Contenedor de las formas animadas */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none', // Asegura que el fondo no interfiera con los clics
        }}
      >
        {shapes.map((shape, index) => (
          <Box
            key={index}
            sx={{
              position: 'absolute',
              width: `${shape.size}px`,
              height: `${shape.size}px`,
              top: shape.top,
              left: shape.left,
              backgroundColor: shape.color,
              borderRadius: '50%', // Para que sean círculos
              opacity: 0.6,
              filter: 'blur(10px)', // Para que se vean como burbujas de fondo suaves
              animation: `${moveShapes} ${shape.duration} infinite alternate ${shape.delay} ease-in-out`,
            }}
          />
        ))}
      </Box>

      {/* Contenido principal de la página */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {children}
      </Box>
    </Box>
  );
};

export default FondoDinamico;